import { render, staticRenderFns } from "./NewVie.vue?vue&type=template&id=9510d110&scoped=true"
import script from "./NewVie.vue?vue&type=script&lang=js"
export * from "./NewVie.vue?vue&type=script&lang=js"
import style0 from "./NewVie.vue?vue&type=style&index=0&id=9510d110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9510d110",
  null
  
)

export default component.exports